// Cursos foco · vista Oficial.
import React from 'react';
import { BookOpen, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function FocusCourses({ cursos = [], loading }) {
  return (
    <section
      aria-label="Cursos foco"
      className="bg-white rounded-2xl border border-[#E5EAF5] p-5"
      data-testid="focus-courses"
    >
      <header className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="font-extrabold text-[#0B1B5E]">Cursos foco</h2>
          <p className="text-xs text-[#475472]">Con más casos activos.</p>
        </div>
        <Link
          to="/admin/dashboard/casos"
          className="text-xs text-[#5346E6] hover:underline font-bold"
          data-testid="link-ver-todos-casos"
        >
          Ver casos
        </Link>
      </header>
      {loading ? (
        <div className="text-sm text-[#475472]">Cargando…</div>
      ) : cursos.length === 0 ? (
        <div className="text-sm text-[#475472] py-4 text-center" data-testid="focus-courses-empty">
          Sin cursos con casos activos.
        </div>
      ) : (
        <ul className="space-y-2" data-testid="focus-courses-list">
          {cursos.map((c) => (
            <li key={c.curso_id} className="flex items-center gap-3 py-2 border-b border-[#F1F3F9] last:border-0">
              <div className="w-8 h-8 rounded-lg bg-[#EEF0FE] flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-[#5346E6]" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-bold text-[#0B1B5E] truncate">{c.curso_nombre || 'Curso sin nombre'}</div>
                <div className="text-[11px] text-[#475472]">
                  {c.n_casos_abiertos} caso{c.n_casos_abiertos !== 1 ? 's' : ''} abierto{c.n_casos_abiertos !== 1 ? 's' : ''}
                  {c.n_rojos > 0 && ` · ${c.n_rojos} rojo${c.n_rojos !== 1 ? 's' : ''}`}
                  {c.n_sentinelas > 0 && ` · ${c.n_sentinelas} centinela`}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-[#94A3B8]" />
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
